import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Role = 'user' | 'assistant' | 'system';

export function Message({
  from,
  children,
  className,
}: {
  from: Role;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex w-full min-w-0',
        from === 'user' ? 'justify-end' : 'justify-start',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function MessageContent({
  from,
  children,
  className,
}: {
  from: Role;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'min-w-0 max-w-[88%] overflow-hidden rounded-lg px-3 py-2 text-sm break-words',
        from === 'user' && 'bg-primary text-primary-foreground',
        from === 'assistant' && 'border border-border bg-card text-card-foreground',
        from === 'system' && 'text-xs text-muted-foreground',
        className,
      )}
    >
      {children}
    </div>
  );
}
